import { Component, OnInit, OnDestroy, NgZone, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { BancoResponse } from 'src/app/global/interfaces/banco-response';
import { CuentaAbonoSubject } from 'src/app/global/services/cuenta-abono-subject.service';
import { cuentaBancaria } from 'src/app/messages/step-2-messages';
import { RutFormatterService } from 'src/app/view-model/services/rut-formatter.service';
import { FlujosPaso2Service } from 'src/app/global/services/flujos-paso-2.service';
import { CuentaAbonoServiceVM } from 'src/app/view-model/services/cuenta-abono-vm.service';
import { Paso1 } from 'src/app/global/interfaces/paso-1';
import { Paso2 } from 'src/app/global/interfaces/paso-2';
import { Product } from 'src/app/view-model/components/shopping-cart/product';
import * as _ from 'lodash';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { TipoCuentaAbonoEnum } from 'src/app/global/enums/tipo-cuenta-abono.enum';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { GoToPaso3ServiceVM } from 'src/app/view-model/services/go-to-paso3.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { StepperServiceVM } from 'src/app/view-model/services/stepper-vm.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import {  clipBoard, clipBoardI, clipBoardIPJ, confirmData } from 'src/app/global/interfaces/cuenta-abono.response';
import { first } from 'rxjs/operators';
import { TipoCuenta } from 'src/app/global/interfaces/tipo-cuenta';
import { ClipboardService } from 'src/app/global/providers/services/clipboard-services/clipboard.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cuenta-bancaria',
  templateUrl: './cuenta-bancaria.component.html',
  styleUrls: ['./cuenta-bancaria.component.scss']
})
export class CuentaBancariaComponent implements OnInit, OnDestroy {

  public mensajeErrorCuentaBancaria = cuentaBancaria;
  cuentaBancariaForm: FormGroup;
  seleccionCuentasForm: FormGroup;
  @Input() showCantidadCampos = true;
  bancos: BancoResponse[] = [];
  tiposCuenta:TipoCuenta[] = [];
  tiposCuentasDefinidos:TipoCuenta[] = [];
  processing = false;
  CInformal = false;
  private hasRun: boolean = false;
  continueForm = true;
  rutEmpresa = false;
  loading = false;
  rutContratacion = '';
  runLogin = '';
  paso1: Paso1;
  paso2: Paso2;
  product: Product;
  esComercioInformal = false;
  idBanco: number;
  tipoCuenta: string;
  oneClick = false;
  changedAccount = false;
  private clickTimeout = null;
  cuentaAbonoInicial = 'CUENTA_PROPIA';
  showPasos = 0;
  screenSize: number;
  private subscription: Subscription;
  private subscription2: Subscription;
  ocultarPasos: boolean;
  disableNumeroCuenta = false;
  private isFromClipboard: boolean = false;
  dataParsedClipboard: clipBoard;

  constructor(
    private fb: FormBuilder,
    private cuentaAbonoSubject: CuentaAbonoSubject,
    private rutFormatterService: RutFormatterService,
    private cuentaAbonoServiceVM: CuentaAbonoServiceVM,
    private flujosPaso2Serv: FlujosPaso2Service,
    private ngZone: NgZone,
    private dialogServ: DialogService,
    private rutFormatter: RutFormatterService,
    private productService: vmProductosService,
    private gotoPaso3Service: GoToPaso3ServiceVM,
    private carroService: CarroComprasService,
    private tagM: TagManagerService,
    private stepperService: StepperServiceVM,
    private storage: LocalStorageService,
    private clipboardSrv : ClipboardService

  ) {
    this.seleccionCuentasForm = this.cuentaAbonoServiceVM.createForm() as FormGroup;
    this.cuentaBancariaForm = this.seleccionCuentasForm.get('cuentaPropia') as FormGroup;

  }

  ngOnInit(): void {
    this.cuentaBancariaForm.get('rut').valueChanges.subscribe(rut => {
      const formattedRut = this.rutFormatterService.format(rut);
      this.validateRutType(formattedRut);
    });
    
    this.cuentaBancariaForm.get('bancos').valueChanges.subscribe(bancoId => {
      this.recargarBancos(bancoId);
    });

    //this.cambiaNombreCuentaBancoChile();
    this.cuentaBancariaForm.get('tipoCuenta').valueChanges.subscribe(() => {
      this.isCuentaRut();
    });

    this.subscription = this.cuentaAbonoServiceVM.bancos().subscribe(bancos => {
      this.bancos = bancos;
      this.clipboardSrv.setBancos(bancos);
      const aux :TipoCuenta[]=[];
      bancos.map( b=>b.relacion).forEach(tcs=>{
                    tcs.forEach(tipocuenta=>aux.some(auxTipoC=>auxTipoC.id ===tipocuenta.id)?false:aux.push(tipocuenta))
            }) ;
      this.tiposCuentasDefinidos=aux;
      this.cambiaNombreCuentaBancos();
    });

    this.screenSize = window.innerWidth;
    this.paso1 = this.storage.getPaso1();
    this.runLogin = this.paso1.run + '';

    this.rutContratacion = this.cuentaBancariaForm.get('rut').value;
    this.cuentaAbonoSubject.showNumPasos$.subscribe(pasos => {
      if (!this.isLowRes()) {
        this.showPasos = pasos;
      } else {
        this.showPasos = 0;
      }
    });
  }


  async init() {
    this.ngZone.run(async () => {
      try {
        this.initializeComponent();
        await this.loadData();
        const cuentaAbono = await this.loadCuentaAbonoData();
        this.processCuentaAbonoData(cuentaAbono);
        this.setLoadingState();

        //modal y funcion getClipboard
        this.abrirModal();
      } catch (error) {
        this.handleError(error);
      }
    });
  }

  private isLowRes(): boolean {
    if (this.screenSize < 768) {
      return true;
    } else {
      return false;
    }
  }

  private validateRutType(rut: string): void {
    const rutNumbers = this.rutFormatterService.getRutFormats(rut).numbers;

    if (this.esEmpresa(rutNumbers)) {
      this.rutEmpresa = true;
      this.cuentaAbonoSubject.showNumberPasos(4);
      this.cuentaBancariaForm.get('primerApellido').setValue('NO APLICA');
    } else {
      this.rutEmpresa = false;
      this.cuentaAbonoSubject.showNumberPasos(6);
      /* this.processing = false; */
      //this.cuentaBancariaForm.get('primerApellido').reset();
    }

    if (rutNumbers === this.rutFormatterService.getRutFormats(this.cuentaBancariaForm.get('rut').value).numbers) {
      this.continueForm = true;
      this.cuentaAbonoSubject.showPasosCuenta();
    }
  }

  /**
   * Valida si el rut pertenece al rango de empresa
   *
   */
  private esEmpresa(rutNumbers: number) {
    return rutNumbers >= 50000000;
  }

  // Inicializa configuraciones generales del componente
  private initializeComponent(): void {
    this.paso2 = this.storage.getPaso2();
    this.flujosPaso2Serv.cuentaBancaria.bloqueado = false;
  }

  // Carga los datos paso 1
  private async loadData(): Promise<void> {
        // Pegar el rut, nombre, apellidos login
        this.cuentaBancariaForm.get('rut').setValue(this.runLogin);
        const nombresLogin = this.paso2.datosPersonales.nombres.nombres;
        const primerApellidoLogin = this.paso2.datosPersonales.nombres.apellidoPaterno;
        const segundoApellidoLogin = this.paso2.datosPersonales.nombres.apellidoMaterno;

        this.cuentaBancariaForm.get('nombresTitular').setValue(nombresLogin);
        this.cuentaBancariaForm.get('primerApellido').setValue(primerApellidoLogin);
        this.cuentaBancariaForm.get('segundoApellido').setValue(segundoApellidoLogin);
  }

  // Carga los datos de cuenta de abono desde el servicio
  private async loadCuentaAbonoData(): Promise<any> {
    const cuentaAbono = await this.cuentaAbonoServiceVM.getCuentaAbono().toPromise();
    this.esComercioInformal = cuentaAbono.comercioInformal !== undefined && cuentaAbono.comercioInformal !== null ? cuentaAbono.comercioInformal : false;
    return cuentaAbono;
  }

  // Procesa los datos de la cuenta de abono obtenidos
  private processCuentaAbonoData(cuentaAbono: any): void {
    const intRun = _.get(cuentaAbono, 'run', 0);
    const dv = this.rutFormatter.getDv(intRun);
    const run = `${intRun}-${dv}`;

    if (cuentaAbono.run > 0 && !this.esComercioInformal) {
      cuentaAbono.tipoPropietario === 'PROPIA'
        ? this.setupCuentaPropia(cuentaAbono, run)
        : this.setupCuentaTerceros(cuentaAbono, run);
    } else {
      this.setupFormForNewAccount();
    }
  }

  // Configura el formulario para una cuenta propia
  private setupCuentaPropia(cuentaAbono: any, run: string): void {
    this.cuentaAbonoInicial = 'CUENTA_PROPIA';
    this.cuentaBancariaForm = this.seleccionCuentasForm.get('cuentaPropia') as FormGroup;
    this.cuentaBancariaForm.get('seleccionarCuenta').setValue(TipoCuentaAbonoEnum.CUENTA_PROPIA);
    this.cuentaBancariaForm.patchValue({
      rutTitular: run,
      nombresTitular: _.get(cuentaAbono, 'nombre.nombres', ''),
      primerApellido: _.get(cuentaAbono, 'nombre.apellidoPaterno', ''),
      segundoApellido: _.get(cuentaAbono, 'nombre.apellidoMaterno', ''),
      bancos: _.get(cuentaAbono, 'banco.id', ''),
      tipoCuenta: cuentaAbono.banco.relacion[0].id,
      numeroCuenta: _.get(cuentaAbono, 'numero', '')
    });
    this.CInformal = true;
    this.recargarBancos(_.get(cuentaAbono, 'banco.id', ''));
  }

  // Configura el formulario para una cuenta de terceros
  private setupCuentaTerceros(cuentaAbono: any, run: string): void {
    this.cuentaAbonoInicial = 'CUENTA_TERCEROS';
    this.cuentaBancariaForm = this.seleccionCuentasForm.get('cuentaTercerosPN') as FormGroup;
    this.cuentaBancariaForm.get('seleccionarCuenta').setValue(TipoCuentaAbonoEnum.CUENTA_TERCEROS);
    const formattedRun = this.rutFormatterService.format(run);
    this.cuentaBancariaForm.get('rut').setValue(formattedRun);
    const runNumbers = this.rutFormatterService.getRutFormats(formattedRun);
    const rut = runNumbers.numbers;
    const nombreTitular = rut >= 50000000 ? _.get(cuentaAbono, 'razonSocial', '') : _.get(cuentaAbono, 'nombre.nombres', '');

    this.cuentaBancariaForm.patchValue({
      nombresTitular: nombreTitular,
      primerApellido: _.get(cuentaAbono, 'nombre.apellidoPaterno', ''),
      segundoApellido: _.get(cuentaAbono, 'nombre.apellidoMaterno', '')
    });

    setTimeout(() => {
      this.cuentaBancariaForm.patchValue({
        bancos: _.get(cuentaAbono, 'banco.id', ''),
        tipoCuenta: cuentaAbono.banco.relacion[0].id,
        numeroCuenta: _.get(cuentaAbono, 'numero', '')
      });
      this.recargarBancos(_.get(cuentaAbono, 'banco.id', ''));
    }, 1000);
  }

  // Configura el formulario para una nueva cuenta si no se encuentra información previa
  private setupFormForNewAccount(): void {
        this.determineCuentainit(this.runLogin);
        this.cuentaAbonoServiceVM.loadForm(this.cuentaBancariaForm, false, false);
        this.rutContratacion = this.cuentaBancariaForm.get('rut').value;
  }

  private determineCuentainit(rut: string): void {
    // Convertir el RUT del input y el runLogin a números enteros
    const run = parseInt(rut.replace(/\D/g, ''), 10);
    const rutlog = parseInt(this.runLogin.replace(/\D/g, ''), 10);

    // Lógica para determinar el tipo de cuenta
    switch (true) {
      // Caso 1: Cuenta Propia
      case rutlog === run:
        console.warn("Es una Cuenta Propia / processing = true ");
        this.cuentaBancariaForm = this.seleccionCuentasForm.get('cuentaPropia') as FormGroup;
        this.CInformal = true;
       this.setupCuentaPropia;
        break;

      // Caso 2: Cuenta Empresa
      case run >= 50000000:
        console.warn("Es una Cuenta Empresa");
        this.cuentaBancariaForm = this.seleccionCuentasForm.get('cuentaEmpresa') as FormGroup;
        this.CInformal = false;
        break;

      // Caso 3: Cuenta Terceros
      case run !== rutlog && run < 50000000:
        console.warn("Es una Cuenta de Terceros");
        this.cuentaBancariaForm = this.seleccionCuentasForm.get('cuentaTercerosPN') as FormGroup;
        this.CInformal = false;
        this.setupCuentaTerceros;
        break;

      default:
        console.error("RUT no válido");
        this.CInformal = true;
        break;
    }
  }
  private determineCuentachange(): void {
    if (this.esComercioInformal) {
      console.warn("No se ejecuta determineCuentachange porque esComercioInformal es true");
      return;
    }
  
    console.warn("Entró al método determineCuentachange");
    const rut = this.cuentaBancariaForm.get('rut').value;
  
    // Convertir el RUT del input y el runLogin a números enteros
    const run = parseInt(rut.split('-')[0].replace(/\D/g, ''), 10);
    const rutlog = this.runLogin.toLowerCase().endsWith('k')
    ? parseInt(this.runLogin.slice(0, -1).replace(/\D/g, ''), 10)
    : parseInt(this.runLogin.replace(/\D/g, '').slice(0, -1), 10);
  
  
    // Lógica para determinar el tipo de cuenta
    switch (true) {
      // Caso 1: Cuenta Propia
      case rutlog === run:
        console.warn("Es una Cuenta Propia / processing = true ");
        this.cuentaBancariaForm = this.seleccionCuentasForm.get('cuentaPropia') as FormGroup;
        this.loadData();
        this.CInformal = true;
        this.esComercioInformal = false;
        // Si los datos provienen del portapapeles, los inyectamos en el formulario:
        if (this.isFromClipboard && this.dataParsedClipboard) {
          this.confirmClipboad(this.dataParsedClipboard);
          this.dataParsedClipboard = null;
          this.isFromClipboard = false;
        }
        break;
  
      // Caso 2: Cuenta Empresa
      case run >= 50000000:
        console.warn("Es una Cuenta Empresa");
        this.cuentaBancariaForm = this.seleccionCuentasForm.get('cuentaEmpresaPN') as FormGroup;
        this.cuentaBancariaForm.get('rut').setValue(rut, { emitEvent: false });
        this.CInformal = false;
        this.rutEmpresa = true;
        this.esComercioInformal = false;
        // Si los datos provienen del portapapeles, los inyectamos en el formulario:
        if (this.isFromClipboard && this.dataParsedClipboard) {
          this.confirmClipboad(this.dataParsedClipboard);
          this.dataParsedClipboard = null;
          this.isFromClipboard = false;
        }
        break;
  
      // Caso 3: Cuenta Terceros
      case run !== rutlog && run < 50000000:
        console.warn("Es una Cuenta de Terceros");
        this.cuentaBancariaForm = this.seleccionCuentasForm.get('cuentaTercerosPN') as FormGroup;
        this.cuentaBancariaForm.get('rut').setValue(rut, { emitEvent: false });
        this.rutEmpresa = false;
        this.CInformal = false;
        this.esComercioInformal = false;
        // Si los datos provienen del portapapeles, los inyectamos en el formulario:
        if (this.isFromClipboard && this.dataParsedClipboard) {
          this.confirmClipboad(this.dataParsedClipboard);
          this.dataParsedClipboard = null;
          this.isFromClipboard = false;
        }
        break;
  
      default:
        console.error("RUT no válido");
        this.CInformal = false;
        this.esComercioInformal = false;
        break;
    }
  }
  

  

  // Maneja el error capturado durante la inicialización del componente
  private handleError(error: any): void {
    this.tagM.logError('Paso 2', error.statusText, error.message);
  }

  // Actualiza el estado de carga y visualización del componente
  private setLoadingState(): void {
    this.flujosPaso2Serv.cuentaBancaria.cargando = false;
    this.flujosPaso2Serv.cuentaBancaria.mostrar = true;
  }


  private determineCuentaType(rut: string): void {
    try {
        // Procesar y validar el RUT ingresado
        const runBody = this.getRutBodyIfValid(rut);
        // Procesar y validar el RUT de login
        const rutlogBody = this.getRutBodyIfValid(this.runLogin);

        // Convertir los cuerpos del RUT a números enteros
        const run = parseInt(runBody, 10);
        const rutlog = parseInt(rutlogBody, 10);

        // Lógica para determinar el tipo de cuenta
        switch (true) {
            // Caso 1: Cuenta Propia
            case rutlog === run:
                console.warn("Es una Cuenta Propia");
                this.saveCuentaPropia();
                break;

            // Caso 2: Cuenta Empresa
            case run >= 50000000:
                console.warn("Es una Cuenta Empresa");
                this.saveCuentaEmpresa();
                this.CInformal = false;
                break;

            // Caso 3: Cuenta Terceros
            case run !== rutlog && run < 50000000:
                console.warn("Es una Cuenta de Terceros");
                this.CInformal = false;
                this.setupCuentaTerceros;
                this.saveCuentaTerceros();
                break;

            default:
                console.error("RUT no válido");
                this.CInformal = false;
                break;
        }
    } catch (error) {
        console.error(error.message);
    }
}

private limpiarCampos() {
  this.cuentaBancariaForm.get('nombresTitular').reset();
  this.cuentaBancariaForm.get('primerApellido').reset();
  this.cuentaBancariaForm.get('segundoApellido').reset();
  this.cuentaBancariaForm.get('bancos').reset();
  this.cuentaBancariaForm.get('bancos').setValue('');
  this.cuentaBancariaForm.get('tipoCuenta').reset();
  this.cuentaBancariaForm.get('tipoCuenta').setValue('');
  this.cuentaBancariaForm.get('numeroCuenta').reset();
}

private getRutBodyIfValid(rut: string): string {
    // Eliminar todos los caracteres que no sean dígitos o 'K'
    const cleanRut = rut.replace(/[^0-9kK]/g, '');
    // Separar el cuerpo del RUT y el dígito verificador
    const body = cleanRut.slice(0, -1);
    const dv = cleanRut.slice(-1).toUpperCase();

    // Validar que el cuerpo del RUT tenga al menos un dígito
    if (body.length < 1) {
        throw new Error("El RUT proporcionado es demasiado corto");
    }

    // Calcular el dígito verificador esperado
    const expectedDv = this.rutFormatter.getDv(Number(body)).toString().toUpperCase();

    // Validar el dígito verificador
    if (expectedDv !== dv) {
        throw new Error(`Dígito verificador incorrecto para el RUT ${rut}`);
    }

    // Retornar el cuerpo del RUT si es válido
    return body;
}

goToLogin(): void {
  location.href = environment.redirections.marketplace;
}

   // Métodos saveCuentaPropia
   async saveCuentaPropia() {
    try {
      this.cuentaBancariaForm.get('rut').setValue(this.runLogin);

      await this.cuentaAbonoServiceVM.saveForm(this.cuentaBancariaForm);
      this.tagM.logDL_cuentaAbono(this.esCuentaPropia);
      this.goToPaso3();
      console.warn("Guardo CuentaPropia");
    } catch (error) {
      this.processing = false;
      this.tagM.logError('Paso 2', error.statusText, error.message);

      // Imprimir el error completo en la consola
      console.error('Error al guardar la cuenta propia:', error);
    }
  }


  async saveCuentaTerceros() {
    try {
      this.cuentaBancariaForm.get('seleccionarCuenta').setValue(TipoCuentaAbonoEnum.CUENTA_TERCEROS);
      await this.cuentaAbonoServiceVM.saveForm(this.cuentaBancariaForm);
      this.tagM.logDL_cuentaAbono(this.esCuentaPropia);
      this.goToPaso3();
      console.warn("Guardo CuentaTerceros");
    } catch (error) {
      this.processing = false;
      this.tagM.logError('Paso 2', error.statusText, error.message);
    }
  }




     // Agrega este nuevo método si es necesario
     async saveCuentaEmpresa() {
      try {
        this.cuentaBancariaForm.get('seleccionarCuenta').setValue(TipoCuentaAbonoEnum.CUENTA_EMPRESA);
        await this.cuentaAbonoServiceVM.saveForm(this.cuentaBancariaForm);
        // Lógica para guardar cuenta empresa
        const runNumbers = this.rutFormatterService.getRutFormats(this.cuentaBancariaForm.get('rut').value);
        const run = runNumbers.numbers;
        if (run >= 50000000) {
          this.cuentaBancariaForm.get('primerApellido').setValue('vacio');
          this.cuentaBancariaForm.get('segundoApellido').setValue('vacio');
        }
        this.goToPaso3();
        console.warn("Guardo CuentaEmpresa");
      } catch (error) {
        this.processing = false;
        this.tagM.logError('Paso 2', error.statusText, error.message);
      }
    }



  get esCuentaPropia(): boolean {
    const cuenta = this.cuentaBancariaForm.get('seleccionarCuenta').value;
    let esCuentaPropia = false;
    if (cuenta === TipoCuentaAbonoEnum.CUENTA_PROPIA) {
      esCuentaPropia = true;
      this.processing = true;
    }
    return esCuentaPropia;
  }



  registraSeleccionProducto() {
    try {
      this.productService.registraSeleccionProductoActual().toPromise();
    } catch (error) {
      this.tagM.logError('Paso 2', error.statusText, error.message);
    }
  }


  private async goToPaso3() {
    try {
      const gevent = GoogleTagManager.eventInteracciones().categoriaCuentaBancaria().setAccion("click");
      this.tagM.logEvent(gevent.setEtiqueta("continuar").setIsPersonaNatural(true));
      const respuesta = await this.gotoPaso3Service.goToPaso3();
      if (respuesta === 'GOTO_PASO_3') {
        this.stepperService.nextStep();
      }
    } catch (e) {
      console.error('Error final: ', e);
    }
  }

  get flujos() {
    return this.flujosPaso2Serv;
  }


  get rutEmpresaControl(): FormControl {
    return this.cuentaBancariaForm.get('rut') as FormControl;
  }

recargarBancos(bancoId: unknown) {
  const bancoSeleccionado = this.bancos.find((i) => Number(i.id) === Number(bancoId));
  if (bancoSeleccionado) {
    const rut = this.rutFormatter.format(this.rutEmpresaControl.value);
    if (Number(bancoId) === 12 && this.rutFormatter.getRutFormats(rut).numbers >= 50000000) {
      this.tiposCuenta = [];
      this.tiposCuenta[0] = bancoSeleccionado.relacion[0];
    } else {
      this.tiposCuenta = bancoSeleccionado.relacion;
    }
  } else {
    this.tiposCuenta = [];
  }
}

  isCuentaRut(): void {
    const idBanco = Number(this.cuentaBancariaForm.get('bancos').value);
    const tipoCuenta = this.cuentaBancariaForm.get('tipoCuenta').value;

    if (idBanco === 12 && tipoCuenta === 'RUT') {
      const cuentaRut = this.rutFormatterService.getRutFormats(this.cuentaBancariaForm.get('rut').value).numbers;
      this.cuentaBancariaForm.get('numeroCuenta').setValue(cuentaRut);
      this.disableNumeroCuenta = true;
    } else {
      this.cuentaBancariaForm.get('numeroCuenta').reset();
      this.disableNumeroCuenta = false;
    }
  }

  continue(): void {
    this.continueForm = true;
    this.cuentaAbonoSubject.showPasosCuenta();
    //this.cuentaAbonoSubject.showNumberPasos(3);
  }


  ngOnDestroy(): void {
    // Desuscribirse de todas las suscripciones al destruir el componente
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscription2) {
      this.subscription2.unsubscribe();
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  ContinuarGuardar($event: any) {
    $event.stopPropagation();
    if (this.cuentaBancariaForm.valid) {
            this.clickTimeout = setTimeout(() => this.onSaveClick(), 100);
    }
  }

  save() {
    this.determineCuentaType(this.cuentaBancariaForm.get('rut').value);
  }

  onSaveClick() {
    this.modalConfirmardatos();
  }


  cambiaNombreCuentaBancos(){
    //Banco de Chile
    var indexBanco = this.bancos.findIndex((b => b.id === 24))
    var indexRelacion = this.bancos[indexBanco].relacion.findIndex ((r => r.id = "CORRIENTE"));
    this.bancos[indexBanco].relacion[indexRelacion].descripcion = "Cuenta Corriente / Cuenta Vista";

    //Banco BCI
    indexBanco = this.bancos.findIndex((b => b.id === 2))
    indexRelacion = this.bancos[indexBanco].relacion.findIndex ((r => r.id = "CORRIENTE"));
    this.bancos[indexBanco].relacion[indexRelacion].descripcion = "Cuenta Corriente / Cuenta Vista";
  }

  /* Modal init */

  abrirModal() {
    ($('#clipboardModal') as any).modal('show');
  }

  cerrarModal() {
    console.warn('Permitir acceso al portapapeles');
    //this.getClipboard(); // Metodo
    ($('#clipboardModal') as any).modal('hide'); // Cierra el modal
    this.modalCopiardatos();
  }


  levantaInput() {
    if (this.hasRun) {
      return;
    }
    // this.getClipboard();
    this.modalCopiardatos();
    this.hasRun = true;
  }


   modalCopiardatos():void {

    this.clipboardSrv.modalCopiardatos().then(result=>{
      if (result.action === 'OK') {
          this.confirmClipboad(result.dataParsed);
          this.isCuentaRut();
          this.validarCaracteresNombreTitular();
      }

    });

   }


   private confirmClipboad(dataParsed: clipBoard) {

    if (!this.esComercioInformal) {
      const rutNumbers = this.rutFormatterService.getRutFormats(dataParsed.rut).numbers;

      this.cuentaBancariaForm.get('rut').setValue(dataParsed.rut);
      this.cuentaBancariaForm.get('nombresTitular').setValue(this.esEmpresa(rutNumbers)?dataParsed.razonSocial:dataParsed.nombre.nombresTitular);
      this.cuentaBancariaForm.get('primerApellido').setValue(dataParsed.nombre.primerApellido);
      this.cuentaBancariaForm.get('segundoApellido').setValue(dataParsed.nombre.segundoApellido);
    }

    this.cuentaBancariaForm.get('bancos').setValue(dataParsed.banco.id);
    this.cuentaBancariaForm.get('bancos').valueChanges.pipe(first()).subscribe(() => {
      this.cuentaBancariaForm.get('tipoCuenta').setValue(dataParsed.tipoCuenta.id);
    });
    this.cuentaBancariaForm.get('tipoCuenta').setValue(dataParsed.tipoCuenta.id);
    this.cuentaBancariaForm.get('numeroCuenta').setValue(dataParsed.cuenta);
  }

/* Modal pegar */
modalConfirmardatos() {
    // Obtén los valores del formulario
    const dataParsed = this.cuentaBancariaForm.value;
    this.isFromClipboard = true;
    const bancoID = Number(dataParsed.bancos);
    const bancoElegido =this.bancos.find(banco=>banco.id===bancoID);
    const tipCuentaElegida =this.tiposCuenta.find(tipoCuenta=>tipoCuenta.id===dataParsed.tipoCuenta);

    const confirmData : confirmData = {
         bancoElegido:bancoElegido,
        numeroCuenta:dataParsed.numeroCuenta,
        razonSocial:dataParsed.nombresTitular,
        rutEmpresa: dataParsed.rut,
        tipCuentaElegida:tipCuentaElegida

    }

    this.clipboardSrv.modalConfirmardatos(confirmData).then((response)=>{
      if (response && response  === 'OK') {
        this.loading = true;
        this.processing = true;
        this.save();
      }
    })
}

validarCaracteresNombreTitular(){
  const value =this.cuentaBancariaForm.get('nombresTitular').value;
  if(!this.rutEmpresa){
      this.cuentaBancariaForm.get('nombresTitular').setValue( value.replace(/[^a-zA-Z\u00f1\u00d1\s]/g, ''));  }
  }

}
